import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
const Tag = React.forwardRef(function Tag2({ icon, className, children, ...rest }, ref) {
  return /* @__PURE__ */ jsxs("span", { ref, className: cx("ev-tag", className), ...rest, children: [
    icon != null && icon !== false ? /* @__PURE__ */ jsx("span", { className: "ev-tag__icon", "aria-hidden": "true", children: icon }) : null,
    children
  ] });
});
export {
  Tag
};
//# sourceMappingURL=Tag.js.map
